import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo } from "react";
import { Anchor } from "@mantine/core";
import { ethers } from "ethers";
import { buildContractTokenUrl, buildContractUrl, buildOpenSeaCollectionUrl, networkLookup, } from "../../utils/blockExplorer";
import { maskAddress } from "../../utils/content";
import CopyButton from "../widgets/CopyButton";
const ExternalCollectionLink = ({ chainId, address, addressType = "token", anchorAddress = true, startAddress = 6, endAddress = 4, }) => {
    const networkData = networkLookup(chainId);
    const blockExplorerUrl = addressType === "token"
        ? buildContractTokenUrl(networkData.type, address)
        : buildContractUrl(networkData.type, address);
    const compactAddress = maskAddress(address, startAddress, endAddress);
    const isEtherAddr = ethers.utils.isAddress(address);
    if (isEtherAddr) {
        return (_jsxs(_Fragment, { children: [anchorAddress ? (_jsx(Anchor, { inherit: true, href: blockExplorerUrl, title: "block explorer link", target: "_blank", rel: "noreferrer", children: compactAddress })) : (compactAddress), _jsx(CopyButton, { copyValue: address, preventDefault: true })] }));
    }
    return (_jsxs(_Fragment, { children: [anchorAddress ? (_jsx(Anchor, { inherit: true, href: buildOpenSeaCollectionUrl(address, networkLookup(chainId).type), title: "os collection link", target: "_blank", rel: "noreferrer", children: address })) : (address), _jsx(CopyButton, { copyValue: address, preventDefault: true })] }));
};
export default memo(ExternalCollectionLink);
